import { render, staticRenderFns } from "./PermissionPassword.vue?vue&type=template&id=b2e8d41c&"
import script from "./PermissionPassword.vue?vue&type=script&lang=js&"
export * from "./PermissionPassword.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports